import { render, staticRenderFns } from "./Academy.vue?vue&type=template&id=2c449e4a&scoped=true&"
import script from "./Academy.vue?vue&type=script&lang=js&"
export * from "./Academy.vue?vue&type=script&lang=js&"
import style0 from "./Academy.vue?vue&type=style&index=0&id=2c449e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c449e4a",
  null
  
)

export default component.exports